import React, { FunctionComponent } from "react";

interface UpdatesIconProps {
    className?: string;
}

const UpdatesIcon: FunctionComponent<UpdatesIconProps> = (
    props: UpdatesIconProps
) => {
    return (
        <div className={props.className}>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.85355 1.14645C9.65829 0.951184 9.34171 0.951184 9.14645 1.14645C8.95118 1.34171 8.95118 1.65829 9.14645 1.85355L10.2929 3H9.5C5.35786 3 2 6.35786 2 10.5C2 14.6421 5.35786 18 9.5 18C13.6421 18 17 14.6421 17 10.5C17 10.2239 16.7761 10 16.5 10C16.2239 10 16 10.2239 16 10.5C16 14.0899 13.0899 17 9.5 17C5.91015 17 3 14.0899 3 10.5C3 6.91015 5.91015 4 9.5 4H10.2929L9.14645 5.14645C8.95118 5.34171 8.95118 5.65829 9.14645 5.85355C9.34171 6.04882 9.65829 6.04882 9.85355 5.85355L11.8536 3.85355C12.0488 3.65829 12.0488 3.34171 11.8536 3.14645L9.85355 1.14645ZM13.3467 7.13976C13.5457 7.33125 13.5517 7.64778 13.3602 7.84673L9.51027 11.8467C9.41601 11.9447 9.28595 12 9.15002 12C9.0141 12 8.88403 11.9447 8.78978 11.8467L7.13975 10.1324C6.94826 9.93339 6.95431 9.61687 7.15327 9.42537C7.35223 9.23388 7.66876 9.23993 7.86025 9.4389L9.15003 10.779L12.6398 7.15327C12.8313 6.95431 13.1478 6.94826 13.3467 7.13976Z" fill="currentColor" />
            </svg>
        </div>
    );
};

export default UpdatesIcon;
